import React from 'react';
import { Text } from '@mantine/core';

/**
 * Une phrase d'explication entre deux champs de l'inspecteur.
 *
 * Même mécanique que `puckSectionField` : une entrée de `fields` qui rend du
 * texte et **n'écrit aucune prop** — elle ne touche jamais à `onChange`. D'où
 * la même convention de clé `_note*`, et la même interdiction de la déclarer
 * dans `defaultProps` : rien ne doit atterrir dans les données.
 *
 * À réserver à ce qu'un `description` de champ ne peut pas porter : une
 * précision qui vaut pour plusieurs réglages, ou qui dit pourquoi un réglage a
 * disparu.
 */
export const puckNoteField = (text) => ({
  type: 'custom',
  label: '',
  render: () => <Text size="xs" c="gray.7">{text}</Text>,
});

export default puckNoteField;
